import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import { Container, Row, Col, Table } from "react-bootstrap";
import PrevQPFile from "../Recruitment/PrevQP";
import { Prev } from "react-bootstrap/esm/PageItem";

function Main(props) {
  const [activeIndex, setActiveIndex] = useState(props.activeIndex);

  const handleToggle = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const PrevQP = [
    {
      name: "Junior Technician - Chemistry Level-I 2024 (QP) ",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2024/qp/Junior_Technician_Chemistry_Level_1(2024)_QP.pdf",
    },
    {
      name: "Deputy Registrar Screening Part A 2024 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2024/qp/DR-S-A.pdf",
    },
    {
      name: "Student Counsellor Screening Test 2024 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2024/qp/SC-S.pdf",
    },
    {
      name: "Hindi Translator Level I 2024 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2024/qp/HT-L1.pdf",
    },
    {
      name: "Junior Nursing Officer Level I 2024 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2024/qp/JNO-L1.pdf",
    },
    {
      name: "Junior Assistant Level I 2024 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2024/qp/JA-L1.pdf",
    },
    {
      name: "Junior Technician Systems Level I 2024 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2024/qp/JT-SYS-L1.pdf",
    },
    {
      name: "Junior Technician Work Shop Level I 2024 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2024/qp/JT-WS-L1.pdf",
    },

    {
      name: "Deputy Registrar 2023 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Deputy Registrar.pdf",
    },
    {
      name: "Junior Superintendent 2023 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Superintendent.pdf",
    },
    {
      name: "Junior Assistant 2023 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior_Assistant_2023.pdf",
    },
    {
      name: "Junior Technical Superintendent (Computer Science and Engineering) 2023 (QP Level-1A)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Technical Superintendent Computer Science and engineering.pdf",
    },
    {
      name: "Junior Technical Superintendent (Computer Science and Engineering) 2023 (QP Level-1B)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/JTS_CSE-Lev IB.pdf",
    },
    {
      name: "Junior Technical Superintendent Systems 2023 (QP Level-1A)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Technical Superintendent Systems.pdf",
    },
    {
      name: "Junior Technical Superintendent Systems 2023 (QP Level-1B)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/JTS_Sys-Lev IB.pdf",
    },
    {
      name: "Junior Technician Systems 2023 (QP Level-1A)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Technician CSE.pdf",
    },
    {
      name: "Junior Technician Systems 2023 (QP Level-1B)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/JT_Sys-Lev IB.pdf",
    },
    {
      name: "Junior Technician Chemistry 2023 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Technician Chemistry.pdf",
    },
    {
      name: "Junior Technician Civil Engineering 2023 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Technician Civil Engineering.pdf",
    },
    {
      name: "Junior Technician Physics 2023 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Technician Physics.pdf",
    },
    {
      name: "Junior Technician Workshop Fitter 2023 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Technician Workshop Fitter.pdf",
    },
    {
      name: "Junior Technician Workshop Machinist 2023 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Technician Workshop machinist.pdf",
    },
    {
      name: "Junior Technician Workshop Welder 2023 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Technician Workshop welder.pdf",
    },
    {
      name: "Physical Training Instructor 2023 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Physical Training Instructor.pdf",
    },
    {
      name: "Assistant Registrar 2022 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/QP/2022/AR_2022_QP.pdf",
    },
    {
      name: "Junior Superintendent 2022 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/QP/2022/JS_2022_QP.pdf",
    },
    {
      name: "Junior Assistant 2022 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/QP/2022/JA_2022_QP.pdf",
    },
    {
      name: "Deputy Registrar 2020 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/QP/2020/Deputy Registrar_2020.pdf",
    },
    {
      name: "Assistant Registrar 2020 (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/QP/2020/Assistant Registrar_2020.pdf",
    },
    {
      name: "Junior Assistant 2020 CPT (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/QP/2020/Junior Assistant_2020_CPT.pdf",
    },
    {
      name: "Junior Assistant 2020 DES (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/QP/2020/Junior Assistant_2020_DES.pdf",
    },
    {
      name: "Junior Assistant 2020 QP (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/QP/2020/Junior Assistant_2020_QP.pdf",
    },
    {
      name: "Deputy Registrar QP 2019",
      link: "https://files.iittp.ac.in/pdfs/recruitment/QP/2019/Deputy Registrar_QP_2019.pdf",
    },
    {
      name: "Assistant Registrar QP 2019",
      link: "https://files.iittp.ac.in/pdfs/recruitment/QP/2019/Assistant Registrar_QP_2019.pdf",
    },
    {
      name: "Junior Superintendent 2019 CPT (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/QP/2019/Junior Superintendant_2019_CPT_Scanned.pdf",
    },
    {
      name: "Junior Superintendent 2019 Des (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/QP/2019/Junior Superintendant_2019_Des.pdf",
    },
    {
      name: "Junior Superintendent 2019 QP (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/QP/2019/Junior Superintendant_2019_QP_Scanned.pdf",
    },
    {
      name: "Junior Assistant 2019 CPT (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/QP/2019/Junior Assistant_2019_CPT_Scanned.pdf",
    },
    {
      name: "Junior Assistant 2019 Des (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/QP/2019/Junior Assistant_2019_Des_Scanned.pdf",
    },
    {
      name: "Junior Assistant 2019 QP (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/QP/2019/Junior Assistant_2019_QP_Scanned.pdf",
    },
    {
      name: "Junior Superintendent 2018 Des CPT (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/QP/2018/Junior Superintendant_2018_Des_CPT.pdf",
    },
    {
      name: "Junior Superintendent 2018 QP (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/QP/2018/Junior Superintendant_2018_QP.pdf",
    },
    {
      name: "Junior Assistant 2018 QP (QP)",
      link: "https://files.iittp.ac.in/pdfs/recruitment/QP/2018/Junior Assistant_2018_QP.pdf",
    },
  ];

  // const Question2023 = [

  //         {
  //             "name": "Deputy Registrar 2023 (QP)",
  //             "link": "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Deputy Registrar.pdf"
  //         },
  //         {
  //             "name": "Junior Superintendent 2023 (QP)",
  //             "link": "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Superintendent.pdf"
  //         },
  //         {
  //             "name": "Junior Assistant 2023 (QP)",
  //             "link": "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior_Assistant_2023.pdf"
  //         },
  //         {
  //             "name": "Junior Technical Superintendent (Computer Science and Engineering) 2023 (QP Level-1A)",
  //             "link": "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Technical Superintendent Computer Science and engineering.pdf"
  //         },
  //         {
  //             "name": "Junior Technical Superintendent (Computer Science and Engineering) 2023 (QP Level-1B)",
  //             "link": "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/JTS_CSE-Lev IB.pdf"
  //         },
  //         {
  //             "name": "Junior Technical Superintendent Systems 2023 (QP Level-1A)",
  //             "link": "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Technical Superintendent Systems.pdf"
  //         },
  //         {
  //             "name": "Junior Technical Superintendent Systems 2023 (QP Level-1B)",
  //             "link": "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/JTS_Sys-Lev IB.pdf"
  //         },
  //         {
  //             "name": "Junior Technician Systems 2023 (QP Level-1A)",
  //             "link": "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Technician CSE.pdf"
  //         },
  //         {
  //             "name": "Junior Technician Systems 2023 (QP Level-1B)",
  //             "link": "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/JT_Sys-Lev IB.pdf"
  //         },
  //         {
  //             "name": "Junior Technician Chemistry 2023 (QP)",
  //             "link": "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Technician Chemistry.pdf"
  //         },
  //         {
  //             "name": "Junior Technician Civil Engineering 2023 (QP)",
  //             "link": "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Technician Civil Engineering.pdf"
  //         },
  //         {
  //             "name": "Junior Technician Physics 2023 (QP)",
  //             "link": "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Technician Physics.pdf"
  //         },
  //         {
  //             "name": "Junior Technician Workshop Fitter 2023 (QP)",
  //             "link": "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Technician Workshop Fitter.pdf"
  //         },
  //         {
  //             "name": "Junior Technician Workshop machinist 2023 (QP)",
  //             "link": "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Technician Workshop machinist.pdf"
  //         },
  //         {
  //             "name": "Junior Technician Workshop welder 2023 (QP)",
  //             "link": "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Junior Technician Workshop welder.pdf"
  //         },
  //         {
  //             "name": "Physical Training Instructor 2023 (QP)",
  //             "link": "https://files.iittp.ac.in/pdfs/recruitment/2023/qp/Physical Training Instructor.pdf"
  //         },

  //     {
  //         "name": "Detailed Advertisement for Various Non-Teaching Positions (Regular)",
  //         "link": "https://files.iittp.ac.in/pdfs/recruitment/2023/Detailed advertisement - Staff 02-2023.pdf"
  //     },
  //     {
  //         "name": "Employment News Advertisement (Hindi)",
  //         "link": "https://files.iittp.ac.in/pdfs/recruitment/2023/Hindi_Advertisement.pdf"
  //     },
  //     {
  //         "name": "Newspaper Advertisement",
  //         "link": "https://files.iittp.ac.in/pdfs/recruitment/2023/Newspaper_add.jpg"
  //     }

  // ]

  const StaffReq = [
    {
      NameofthePost: "Deputy Librarian",
      Syllabus: " --- ",
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/DL_Shortlisting.pdf",
          Text: "1. Shortlisting Status",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/Representation DL.pdf",
          Text: "2. Representation Status",
        },
      ],
      DateofExamination: "25th November 2023",
      Results: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/Selected/DL Final Results.pdf",
        Text: "Selected List",
        Style: {
          color: "darkgreen",
          "text-align": "justify",
        },
        glowstatus: "yes",
      },
    },
    {
      NameofthePost: "Deputy Registrar",
      Syllabus: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/syllabus/DR_Syllabus.pdf",
        Text: "Click Here",
        Style: {
          color: "blue",
        },
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/DR_Shortlisting.pdf",
          Text: "1. Shortlisting Status",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/DR Status of Representation.pdf",
          Text: "2. Representation Status",
        },
      ],
      DateofExamination: "25th and 26th November 2023",
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/Results/Screening test Results _DR.pdf",
          Text: "1. Screening Test Results",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/Selected/DR Final Results.pdf",
          Text: "2. Selected List",
          color: "green",
          glowstatus: "yes",
        },
      ],
    },
    {
      NameofthePost: "Junior Superintendent",
      Syllabus: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/syllabus/JS_Syllabus.pdf",
        Text: "Click Here",
        Style: {
          color: "blue",
        },
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/JS_Shortlisting.pdf",
          Text: "1. Shortlisting Status",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/Representation status - JS.pdf",
          Text: "2. Representation Status",
        },
      ],
      DateofExamination: "18th and 19th November 2023",
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/Results/Level-I Results JS.pdf",
          Text: "1. Level-I Results",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/Selected/JS.pdf",
          Text: "2. Selected List",
          color: "green",
          glowstatus: "yes",
        },
      ],
    },

    {
      NameofthePost: "Junior Assistant",
      Syllabus: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/syllabus/JA_Syllabus.pdf",
        Text: "Click Here",
        Style: {
          color: "blue",
        },
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/JA_Shortlisting.pdf",
          Text: "1. Shortlisting Status",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/Representation JA.pdf",
          Text: "2. Representation Status",
        },
      ],
      DateofExamination: "2nd and 3rd December 2023",
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/Results/Level-I Results JA.pdf",
          Text: "1. Level-I Result",
          color: {
            color: "darkgreen",
            "text-align": "justify",
          },
          glowstatus: "yes",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/Selected/JA.pdf",
          Text: "2. Selected List",
          color: "green",
          glowstatus: "yes",
        },
      ],
    },

    {
      NameofthePost: "Junior Hindi Assistant Gr-I",
      Syllabus: " --- ",
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/JHA_Shortlisting.pdf",
          Text: "1. Shortlisting Status",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/Representation Status JHA Gr-I.pdf",
          Text: "2. Representation Status",
        },
      ],
      DateofExamination: "---",
      Results: "---",
    },
    {
      NameofthePost:
        "Junior Technical Superintendent - Systems (Computer Centre)",
      Syllabus: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/syllabus/JTS-Systems_Syllabus.pdf",
        Text: "Click Here",
        color: "blue",
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/JTS Sys CC Screening.pdf",
          Text: "1. Shortlisting Status",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/Representation Status JTS Sys CC.pdf",
          Text: "2. Representation Status",
        },
      ],
      DateofExamination: "22nd and 23rd November 2023",
      Results: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/Selected/JTS_Systems.pdf",
        Text: "Selected List",
        color: "green",
        glowstatus: "yes",
      },
    },
    {
      NameofthePost:
        "Junior Technical Superintendent – Computer Science and Engineering",
      Syllabus: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/syllabus/JTS-CSE-Syllabus.pdf",
        Text: "Click Here",
        color: "blue",
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/JTS CSE Screening.pdf",
          Text: "1. Shortlisting Status",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/Representation Status JTS CSE.pdf",
          Text: "2. Representation Status",
        },
      ],
      DateofExamination: "22nd and 23rd November 2023",
      Results: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/Selected/JTS_CSE.pdf",
        Text: "Selected List",
        color: "green",
        glowstatus: "yes",
      },
    },
    {
      NameofthePost: "Junior Technician - Civil Engineering",
      Syllabus: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/syllabus/JT-CEE_Syllabus.pdf",
        Text: "Click Here",
        color: "blue",
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/JT-CEE-Shortlisting.pdf",
          Text: "Shortlisted / Not shortlisted",
        },
      ],
      DateofExamination: "21st and 22nd November 2023",
      Results: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/Selected/JT_CE.pdf",
        Text: "Selected List",
        color: "green",
        glowstatus: "yes",
      },
    },

    {
      NameofthePost: "Junior Technician - Physics",
      Syllabus: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/syllabus/JT-Physics_Syllabus.pdf",
        Text: "Click Here",
        color: "blue",
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/JT-Physics_Shortlisting.pdf",
          Text: "1. Shortlisting Status",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/Representation Status JT Physics.pdf",
          Text: "2. Representation Status",
        },
      ],
      DateofExamination: "8th and 9th November 2023",
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/Results/Level-I Results JT PH.pdf",
          Text: "1. Level-I Results",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/Selected/JT_PH.pdf",
          Text: "2. Selected List",
          color: "green",
          glowstatus: "yes",
        },
      ],
    },
    {
      NameofthePost: "Junior Technician - Systems (Computer Centre)",
      Syllabus: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/syllabus/JT-Systems_Syllabus.pdf",
        Text: "Click Here",
        color: "blue",
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/JT Sys CC Screening.pdf",
          Text: "1. Shortlisting Status",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/Representation Status JT Sys CC.pdf",
          Text: "2. Representation Status",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/Revised Representation Status JT Sys CC.pdf",
          Text: "3. Revised Representation Status",
        },
      ],
      DateofExamination: "22nd and 23rd November 2023",
      Results: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/Selected/JT_Systems.pdf",
        Text: "Selected List",
        color: "green",
        glowstatus: "yes",
      },
    },
    {
      NameofthePost: "Junior Technician -Workshop",
      Syllabus: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/syllabus/JT-Workshop_Syllabus.pdf",
        Text: "Click Here",
        color: "blue",
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/JT-WS_Shortlisting.pdf",
          Text: "1. Shortlisting Status",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/JT-WS_Revised_Shortlisting.pdf",
          Text: "2. Revised List",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/JT WS Representation Status.pdf",
          Text: "3. Representation Status",
        },
      ],
      DateofExamination: "10th and 11th November 2023",
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/Results/Level-I Results JT WS.pdf",
          Text: "1. Level-I Results",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/Selected/JT_WS.pdf",
          Text: "2. Selected List",
          color: "green",
          glowstatus: "yes",
        },
      ],
    },
    {
      NameofthePost: "Junior Technician -Chemistry",
      Syllabus: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/syllabus/JT-Chemistry_Syllabus.pdf",
        Text: "Click Here",
        color: "blue",
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/JT-CY-Shortlisting.pdf",
          Text: "1. Shortlisting Status",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/Representation Status JT Chemistry.pdf",
          Text: "2. Representation Status",
        },
      ],
      DateofExamination: "17th and 18th November 2023",
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/Results/Level-I Results JT CH.pdf",
          Text: "1. Level-I Results",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/Selected/JT_CY.pdf",
          Text: "2. Selected List",
          color: "green",
          glowstatus: "yes",
        },
      ],
    },
    {
      NameofthePost: "Physical Training Instructor",
      Syllabus: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/syllabus/PTI_Recruitment_Syllabus_and_Selection_Process.pdf",
        Text: "Click Here",
        color: "blue",
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/PTI-Shortlisting.pdf",
          Text: "1.Shortlisted / Not shortlisted",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/shortlisted/Status of representation of PTI.pdf",
          Text: "2. Representation Status",
        },
      ],
      DateofExamination: "9th and 10th November 2023",
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/Results/Level-1 Results PTI.pdf",
          Text: "1. Level-I Results",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2023/Selected/PTI.pdf",
          Text: "2. Selected List",
          color: "green",
          glowstatus: "yes",
        },
      ],
    },
  ];

  const StaffReq2024 = [
    {
      NameofthePost: "Student Counsellor",
      Syllabus: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/syllabus/Syllabus_SC.pdf",
        Text: "Click Here",
        Style: {
          color: "blue",
        },
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Screening_SC.pdf",
          Text: "1. Shortlisting Status",
          glowstatus: "yes",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
          Text: "2. Representation Status",
          glowstatus: "yes",
        },
      ],
      DateofExamination: (
        <>
          Date of Screening Test : 20.10.2024 <br />
          Date of Interview : 21.10.2024
        </>
      ),
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Level-I_Results-SC.pdf",
          Text: "1. Screening Test Results",
          color: {
            color: "darkgreen",
            "text-align": "justify",
          },
          glowstatus: "yes",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/selected/SC_Final_Result.pdf",
          Text: "2. Selected List",
          color: "green",
          glowstatus: "yes",
        },
      ],
    },
    {
      NameofthePost: "Hindi Translator",
      Syllabus: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/syllabus/Syllabus_HT_2024.pdf",
        Text: "Click Here",
        Style: {
          color: "blue",
        },
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Screening_Report_HT.pdf",
          Text: "1. Shortlisting Status",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_HT.pdf",
          Text: "2. Representation Status",
          glowstatus: "yes",
        },
      ],
      DateofExamination: " 06-07-2024 & 07-07-2024 ",
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Level-I_Results-HT.pdf",

          Text: "1. Level-I Results",
          color: {
            color: "darkgreen",
            "text-align": "justify",
          },
          glowstatus: "yes",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/selected/HT_Final_Result.pdf",
          Text: "2. Selected List",
          color: "green",
          glowstatus: "yes",
        },
      ],
    },
    {
      NameofthePost: "Junior Nursing Officer",
      Syllabus: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/syllabus/Syllabus_JNO_2024.pdf",
        Text: "Click Here",
        Style: {
          color: "blue",
        },
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Screening_JNO.pdf",
          Text: "1. Shortlisting Status",
          glowstatus: "yes",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_JNO.pdf",
          Text: "2. Representation Status",
          glowstatus: "yes",
        },
      ],
      DateofExamination: " 26-06-2024 ",
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Level-I_Results_JNO.pdf",
          Text: "1. Level-I Results",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/selected/SelectedList_JNO.pdf",
          Text: "2. Selected List",
          color: "green",
          glowstatus: "yes",
        },
      ],
    },

    {
      NameofthePost: "Junior Assistant",
      Syllabus: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/syllabus/Syllabus_JA_2024.pdf",
        Text: "Click Here",
        Style: {
          color: "blue",
        },
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Screening_JA.pdf",
          Text: "1. Shortlisting Status",
          glowstatus: "yes",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_JA.pdf",
          Text: "2. Representation Status",
          glowstatus: "yes",
        },
      ],
      DateofExamination: " 29-06-2024 & 30-06-2024 ",
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/JA_Level-I_Results.pdf",
          Text: "1. Level-I Results",
          color: {
            color: "darkgreen",
            "text-align": "justify",
          },
          glowstatus: "no",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/selected/SelectedList_JA.pdf",
          Text: "2. Selected List",
          color: "green",
          glowstatus: "yes",
        },
      ],
    },

    {
      NameofthePost:
        "Junior Technician - Systems (Civil & Environmental Engineering)",
      Syllabus: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/syllabus/Syllabus_JT_Sys.pdf",
        Text: "Click Here",
        Style: {
          color: "blue",
        },
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Screening_JT-Sys_Civil.pdf",
          Text: "1. Shortlisting Status",
          glowstatus: "yes",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_JT-Sys.pdf",
          Text: "2. Representation Status",
          glowstatus: "yes",
        },
      ],
      DateofExamination: " 10-7-2024 ",
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Level-I_Results_JT-Sys.pdf",
          Text: "1. Level-I Results",
          color: {
            color: "darkgreen",
            "text-align": "justify",
          },
          glowstatus: "yes",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/selected/JT-Sys_CEE_Final_Result.pdf",
          Text: "2. Selected List",
          color: "green",
          glowstatus: "yes",
        },
      ],
    },
    {
      NameofthePost: "Junior Technician -Workshop",
      Syllabus: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/syllabus/Syllabus_JT_WS_2024.pdf",
        Text: "Click Here",
        Style: {
          color: "blue",
        },
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Screening_JT-WS.pdf",
          Text: "1. Shortlisting Status",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_JT-WS.pdf",
          Text: "2. Representation Status",
          glowstatus: "yes",
        },
      ],
      DateofExamination: " 06-07-2024 & 07-07-2024 ",
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/JT_WS_Level-I_Results.pdf",
          Text: "1. Level-I Results",
          color: {
            color: "darkgreen",
            "text-align": "justify",
          },
          glowstatus: "yes",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/selected/JT-WS_Final_Result.pdf",
          Text: "2. Selected List",
          color: "green",
          glowstatus: "yes",
        },
      ],
    },
  ];

  const StaffReq2024_2 = [
    {
      NameofthePost: "Registrar",
      Syllabus: {
        Link: "",
        Text: "",
        Style: {
          color: "blue",
        },
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/September/shortlisted/Registrar_Screening.pdf",
          Text: "1. Shortlisting Status",
          glowstatus: "",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/September/shortlisted/IITTSTAFFREC022024REGISTRAR02_Screening_Registrar.pdf",
          Text: "2. Final List of Shortlisted Candidates for Online Presentation",
          glowstatus: "",
        },
      ],
      DateofExamination: (
        <>
          Stage-I Screening (Online Presentation) <br /> The online presentation
          is scheduled on 2nd December 2024 <br /> Interview : 14th December
          2024
        </>
      ),
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/September/Selected/Selected_List_Registrar.pdf",
          Text: "Selected List",
          glowstatus: "yes",
          Style: {
            color: "darkgreen",
          },
        },

        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/September/shortlisted/Registrar_Online_Presentation_Result.pdf",
          Text: "Online Presentation Result",
          glowstatus: "",
        },
      ],
    },

    {
      NameofthePost: "Deputy Registrar",
      Syllabus: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/September/syllabus/Syllabus_DR.pdf",
        Text: "Click Here",
        Style: {
          color: "blue",
        },
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/September/shortlisted/DR_Shortlisted_List.pdf",
          Text: "1. Shortlisting Status",
          // glowstatus : "yes"
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/September/shortlisted/IITTSTAFFREC022024DR02_Status_of_Representations.pdf",
          Text: "2. Representation Status",
          glowstatus: "",
        },
      ],
      DateofExamination: (
        <>
          {" "}
          Screening Test : 20th December 2024 <br />
          Interview : 21st December 2024{" "}
        </>
      ),
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/September/Selected/Selected_List_DR.pdf",
          Text: "Selected Candidates List",
          Style: {
            color: "darkgreen",
            "text-align": "justify",
          },
          glowstatus: "yes",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/September/shortlisted/DR_Screening_Results.pdf",
          Text: "Screening Test Results",
          // Style: {
          //     color: "darkgreen",
          //     "text-align": "justify"
          // }
          // glowstatus: "yes"
        },
      ],
    },

    {
      NameofthePost: "Junior Technician - Chemistry",
      Syllabus: {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/September/syllabus/Syllabus_JT_CY.pdf",
        Text: "Click Here",
        Style: {
          color: "blue",
        },
      },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/September/shortlisted/CY_JT_Screening.pdf",
          Text: "1. Shortlisting Status",
          // glowstatus : "yes"
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/September/shortlisted/Representations_JT_CY.pdf",
          Text: "2. Representation Status",
          // glowstatus : "yes"
        },
      ],
      DateofExamination: "3rd January 2025 & 4th January 2025",
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/September/Selected/JT_CY_Results.pdf",
          Text: "Selected Candidates List",
          Style: {
            color: "darkgreen",
            "text-align": "justify",
          },
          glowstatus: "yes",
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/September/shortlisted/CY_JT_Level-1_Results.pdf",
          Text: "Level-I Test Results",
          // Style: {
          //     color: "darkgreen",
          //     "text-align": "justify"
          // },
          // glowstatus: "yes"
        },
      ],
    },
  ];

  const StaffReq2025_1 = [
    {
      NameofthePost: "Assistant Registrar (on Deputation)",
      Syllabus: { Link: "", Text: "---", Style: { color: "black" } },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_Report_AR.pdf",
          Text: "1. Shortlisting Status",
          glowstatus : "yes"
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_AR.pdf",
          Text: "2. Representation Status",
          glowstatus : "yes"
        },
      ],
      DateofExamination: (<>Interview Date: 11<sup>th</sup> October 2025 (Saturday)</>),
      Results: [{
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/AR_Final_Result.pdf",
        Text: "Selection List",
        glowstatus : "yes"}]
    },
    {
      NameofthePost: "Technical Officer - CIF",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_TO_CIF.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_TO.pdf",
          Text: "1. Shortlisting Status"},
           {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_TO.pdf",
          Text: "2. Representation Status",
          glowstatus : "yes"
        },
        ],
      DateofExamination: (<>Screening Test: 04<sup>th</sup> November 2025 <br/>Interview: 05<sup>th</sup> November 2025</>),
      
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/Selection_List_TO.pdf",
          Text: "Selection List",
          glowstatus : "yes"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/Screening_Test_Results_TO.pdf",
          Text: "1. Screening Test Results"
          }]
    },
    {
      NameofthePost: "Security Officer",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_SS.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_SS.pdf",
          Text: "1. Shortlisting Status"},
         {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_SS.pdf",
          Text: "2. Representation Status",
          glowstatus : "yes"
        },
        ],
      DateofExamination: (<>Screening Test: 09<sup>th</sup> November 2025 <br/>Interview: 10<sup>th</sup> November 2025</>),
      Results: [
         {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/SS_Results.pdf",
          Text: "Selection List",
        glowstatus : "yes"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/Screening_Test1_Results_SS.pdf",
          Text: "1.Screeing Test-I Result",  
        }
      ]
    },
    {
      NameofthePost: "Section Officer",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_SO.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_SO.pdf",
          Text: "1. Shortlisting Status"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_SO.pdf",
          Text: "2. Representation Status"}
        ,{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Additional-list_SO.pdf",
          Text: "3. Additional List"}
        ],
      DateofExamination: (<>16th and 17th October 2025</>),
      Results: [
        {
        Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/SO_Results.pdf",
        Text: "Selection List",
        glowstatus : "yes"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/SO_Level-1_Results.pdf",
          Text: "1.Level-I Results"}]
    },
    {
      NameofthePost: "Junior Superintendent",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_JS.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_JS.pdf",
          Text: "1. Shortlisting Status"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_JS.pdf",
          Text: "2. Representation Status",
          glowstatus : "yes"
        },
        ],
      DateofExamination: (<>25th and 26th October 2025</>),
      Results:  [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/JS_Selection_Results.pdf",
          Text: "Selection List",
        glowstatus : "yes"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/JS_Level-1_Results.pdf",
          Text: "1.Level-I Results"
        }]
    },
    {
      NameofthePost: "Junior Engineer – Civil",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_JE-Civil.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_JE.pdf",
          Text: "1. Shortlisting Status"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_JE.pdf",
          Text: "2. Representation Status"
          
        },
        ],
      DateofExamination: (<>Level-1 14th November 2025<br />Level-2 15th November 2025<br />Level-3 16th November 2025</>),
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/JE_Results.pdf",
          Text: "Selection List" ,
        glowstatus: "yes"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/Level-I_Results_JT_Civil_EU.pdf",
          Text: "1.Level-I Results"
          
        }
      ]
    },
    {
      NameofthePost: "Junior Sports Officer",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_JSO.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_JSO.pdf",
          Text: "1. Shortlisting Status"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status-JSO.pdf",
          Text: "2. Representation Status",
          glowstatus : "yes"
        }],
      DateofExamination: (<>22nd and 23rd October 2025</>),
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/JSO_Results.pdf",
          Text: "Selection List" ,
        glowstatus: "yes"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/LEVEL_1_Results_JSO.pdf",
          Text: "1.Level-I Results"}
          ]
    },
    {
      NameofthePost: "Junior Technical Superintendent – Chemical Engineering",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_JTS-CH.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_JTS_CH.pdf",
          Text: "1. Shortlisting Status"},
         {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_JTSCH.pdf",
          Text: "2. Representation Status",
          glowstatus : "yes"
        },
        ],
      DateofExamination: (<>14th and 15th November 2025</>),
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/Selection_Results_JTS-CH.pdf",
          Text: "Selection List",
          glowstatus : "yes"
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/Level-I_Results_JTS-CH.pdf",
          Text: "1.Level-I Results"}
        ]
    },
    {
      NameofthePost: "Junior Technical Superintendent – Dept. of CSE, Software & Systems Development",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_JTS-CSE_Software.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_JTS_CSESSD.pdf",
          Text: "1. Shortlisting Status"},
           {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_JTS_CSESSD.pdf",
          Text: "2. Representation Status",
          glowstatus : "yes"
        },
        ],
      DateofExamination: (<>1st and 2nd December 2025</>),
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/JTSCSESSD_Results.pdf",
          Text: "Selection List",
          glowstatus : "yes"
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/Level_1_Results_JTS_CSE_SSD.pdf",
          Text: "1.Level-I Results"
          }]
    },
    {
      NameofthePost: "Junior Technical Superintendent – Dept. of CSE,  System Administration & Networking",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_JTS-CSE_SystemAdmin.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_JTS_CSESAN.pdf",
          Text: "1. Shortlisting Status"},
          {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_JTS_CSESAN.pdf",
          Text: "2. Representation Status",
          glowstatus : "yes"
        },
        ],
      DateofExamination: (<>1st and 2nd December 2025</>),
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/JTSCSESAN_Results.pdf",
          Text: "Selection List",
          glowstatus : "yes"
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/Level-I_Results_JTS_CSESAN.pdf",
          Text: "1.Level-I Results"
          }]
    },
    {
      NameofthePost: "Junior Technical Superintendent – Systems (Dept. HSS & MAS)",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_JTS-Systems_HSS-MAS.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_JTS_HSS_MAS.pdf",
          Text: "1. Shortlisting Status"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_JTS-MASHSS.pdf",
          Text: "2. Representation Status",
          glowstatus : "yes"
        }],
      DateofExamination: (<>12th and 13th December 2025</>),
      Results: [
         {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/JTSHSSMAS_Results.pdf",
          Text: "Selection List",
          glowstatus : "yes"
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/Level-I_Results_JTS_HSS-MAS.pdf",
          Text: "1.Level-I Results"          
          }
         
        
        ]
      
    },
    {
      NameofthePost: "Junior Technical Superintendent – Systems (Computer Centre)",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_JTS-Systems-CC.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_JTSCC.pdf",
          Text: "1. Shortlisting Status"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_JTS-CC.pdf",
          Text: "2. Representation Status",
          glowstatus : "yes"
        }],
      DateofExamination: (<>22nd and 23rd November 2025</>),
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/JTSCC_Results.pdf",
          Text: "Selection List",
          glowstatus : "yes"
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/Level-I_Results_JTS_Systems_CC.pdf",
          Text: "1.Level-I Results"
          }]
    },
    {
      NameofthePost: "Junior Assistant",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_JA.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_JA.pdf",
          Text: "1. Shortlisting Status"},
           {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_JA.pdf",
          Text: "2. Representation Status",
          glowstatus : "yes"
        },
        ],
      DateofExamination: (<>Level-I: 2<sup>nd</sup> November 2025 <br/>Level-II,III: 15<sup>th</sup> November 2025</>),
      Results: [
         {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/JA_Results.pdf",
          Text: "Selection List" ,
        glowstatus: "yes"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/LEVEL_1_Results_JA.pdf",
          Text: "1.Level-I Results"
          }
        ]
    },
    {
      NameofthePost: "Junior Technician – Chemical Engineering",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_JT-CH.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_JT-CH.pdf",
          Text: "1. Shortlisting Status"},
          {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_JT-CH.pdf",
          Text: "2. Representation Status"}],
      DateofExamination: (<>14th and 15th November 2025</>),
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/Selection_Results_JT-CH.pdf",
          Text: "Selection List",
          glowstatus : "yes"
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/Level-I_Results_JT-CH.pdf",
          Text: "1.Level-I Results",
          }
        ]
    },
    {
      NameofthePost: "Junior Technician – Civil & Environmental Engineering",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_JT_CEE.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_JT-CEE.pdf",
          Text: "1. Shortlisting Status"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_JT-CEE.pdf",
          Text: "2. Representation Status",
          glowstatus : "yes"
        }],
      DateofExamination: (<>4th and 5th December 2025</>),
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/JTCEE_Results.pdf",
          Text: "Selection List",
          glowstatus : "yes"
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/Level-I_Results_JT-CEE.pdf",
          Text: "1. Level-I Results"
          }]
    },
    {
      NameofthePost: "Junior Technician – Computer Science & Engineering",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_JT-CSE.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_JT_CSE.pdf",
          Text: "1. Shortlisting Status"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_JT_CSE.pdf",
          Text: "2. Representation Status",
          glowstatus : "yes"
        },
        ],
      DateofExamination: (<>1st and 2nd December 2025</>),
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/JTCSE_Results.pdf",
          Text: "Selection List",
          glowstatus : "yes"
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/LEVEL_1_Results_JT_CSE.pdf",
          Text: "1. Level-I Results"
          }]
    },
    {
      NameofthePost: "Junior Technician – Electrical Engineering",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_JT-EE.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_JT-EE.pdf",
          Text: "1. Shortlisting Status"},
         {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_JTEE.pdf",
          Text: "2. Representation Status",
          glowstatus : "yes"
        },
        ],
      DateofExamination: (<>12th and 13th November 2025</>),
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/JTEE_Results.pdf",
          Text: "Selection List",
          glowstatus : "yes"
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/LEVEL_1_Results_JT_EE.pdf",
          Text: "1. Level-I Results"
          }]
    },
    {
      NameofthePost: "Junior Technician – Mechanical Engineering",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_JT-ME.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_JT-ME.pdf",
          Text: "1. Shortlisting Status"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_JT-ME.pdf",
          Text: "2. Representation Status"}],
      DateofExamination: (<>12th and 13th November 2025</>),
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/JTME_Results.pdf",
          Text: "Selection List" ,
        glowstatus: "yes"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/LEVEL_1_Results_JT_ME.pdf",
          Text: "1. Level-I Results"
          }]
    },
    {
      NameofthePost: "Junior Technician – Physics",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_JT-PH.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_Report_JT_PH.pdf",
          Text: "1. Shortlisting Status",
          glowstatus : "yes"
        },
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_JTPH.pdf",
          Text: "2. Representation Status",
          glowstatus : "yes"
        },
        // {
        //   Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/September/shortlisted/Representations_JT_CY.pdf",
        //   Text: "2. Representation Status",
        //   // glowstatus : "yes"
        // },
      ],
      DateofExamination: (<>6<sup>th</sup> and 7<sup>th</sup> November 2025</>),
      Results: [
         {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/JTPH_Results.pdf",
          Text: "Selection List" ,
        glowstatus: "yes"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/Level-I_Results_JT-PH.pdf",
          Text: "1.Level-I Results"
          }]
    },
    {
      NameofthePost: "Junior Technician – CIF",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_JT-CIF.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_JT-CIF.pdf",
          Text: "1. Shortlisting Status"
        },
      {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_JTCIF.pdf",
          Text: "2. Representation Status"
        }
      ],
      DateofExamination: (<>15<sup>th</sup> and 16<sup>th</sup> December 2025</>),
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/Selection_Results_JT-CIF.pdf",
          Text: "Selection List",
          glowstatus : "yes"
        },
         {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/Level-I_Results_JT CIF.pdf",
          Text: "1.Level-I Results"
          }
          
      ]
    },
    {
      NameofthePost: "Junior Technician – Engineering Unit (Civil)",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_JT-Civil_EU.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_JT_Civil_EU.pdf",
          Text: "1. Shortlisting Status"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_JTCEU.pdf",
          Text: "2. Representation Status",
          glowstatus : "yes"
        },
        ],
      DateofExamination: (<>Level-1 14th November 2025<br />Level-2 15th November 2025<br />Level-3 16th November 2025</>),
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/JTCEU_Results.pdf",
          Text: "Selection List" ,
        glowstatus: "yes"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/Level-I_Results_JT-Civil-EU.pdf",
          Text: "1.Level-I Results"
          }]
    },
    {
      NameofthePost: "Junior Technician – Centre of Excellence",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_JT_CoE.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [{
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_JT-CoE.pdf",
          Text: "1. Shortlisting Status"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_JT-CoE.pdf",
          Text: "2. Representation Status"}],
      DateofExamination: (<>17<sup>th</sup> & 18<sup>th</sup> November 2025</>),
      Results: [
         {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/JTCoE_Results.pdf",
          Text: "Selection List" ,
        glowstatus: "yes"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/Level-I_Results_JT_CoE.pdf",
          Text: "1.Level-I Results"
          }]
    },
    {
      NameofthePost: "Junior Technician – Computer Centre",
      Syllabus: { Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/syllabus/Syllabus_JT-CC.pdf", Text: "Click here", Style: { color: "blue" } },
      StatusofApplication: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Screening_JTCC.pdf",
          Text: "1. Shortlisting Status"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/shortlisted/Representation_Status_JT-CC.pdf",
          Text: "2. Representation Status",
          glowstatus : "yes"
        }
      ],
      DateofExamination: (<>22nd and 23rd November 2025</>),
      Results: [
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/JTCC_Results.pdf",
          Text: "Selection List" ,
        glowstatus: "yes"},
        {
          Link: "https://files.iittp.ac.in/pdfs/recruitment/2025/July/results/Level-I_Results_JT-CC.pdf",
          Text: "1.Level-I Results"
          }]
    }
  ];


  return (
    <>
      <Header />
      <Breadcrumb title="Home" subtitle="Staff Recruitment" />
      <section className="project-detail">
        <div className="container">
          <div className="c-heading">
            <h1>Staff Recruitment</h1>
          </div>

          <Row>
            <div
              className="col-lg-12 col-md-12  wow fadeInUp animated"
              data-animation="fadeInUp"
              data-delay=".4s"
            >
              <div
                className="faq-wrap pl-30 wow fadeInUp animated"
                data-animation="fadeInUp"
                data-delay=".4s"
              >
                <div className="accordion" id="accordionExample">





                  {/* Index14 ---------------------- start */}

                  <div className="card">
                    <div className="card-header">
                      <h2 className="mb-0">
                        <button
                          className={`faq-btn${
                            activeIndex === 15 ? "" : " collapsed"
                          }`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse15`}
                          onClick={() => handleToggle(15)}
                        >
                          <h3>Staff Recruitment</h3>{" "}
                          <h4>
                            {" "}
                            Advertisement No. IITT/STAFFREC/01/2026 dated
                            31-08-2026
                          </h4>
                        </button>
                      </h2>
                    </div>
                    <div
                      id={`collapse15`}
                      className={`collapse${activeIndex === 15 ? " show" : ""}`}
                      data-bs-parent="#accordionExample"
                    >
                      <div className="card-body">
                        
                        
                          <ul className="myulcustarrow mt-3">
                            <li>
                              <Link
                                to="https://files.iittp.ac.in/2026/recruitment/staff/Detailed_advertisement-Staff_01-2026_IITT_31.08.2026.pdf"
                                target="_blank"
                              >
                                <b className="c-link">
                                  Detailed Advertisement (English Version) - Click Here
                                </b>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="https://files.iittp.ac.in/2026/recruitment/staff/Detailed_advertisement-Staff_01-2026_IITT_31.08.2026_hindi.pdf"
                                target="_blank"
                              >
                                <b className="c-link">
                                  Detailed Advertisement (Hindi Version) - Click Here 
                                  <small style={{ display: "block", marginLeft: "38px" }}>(In the event of any conflict, discrepancy, or inconsistency between the Hindi and English versions, the English version shall prevail and shall be treated as final and binding.)</small>
                                </b>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="https://files.iittp.ac.in/2026/recruitment/staff/NewspaperAdvertisement.pdf"
                                target="_blank"
                              >
                                <b className="c-link">
                                 Newspaper Advertisement -Click Here
                                </b>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="http://iittp.plumerp.co.in/prod/iittirupati/staffactiveadv"
                                target="_blank"
                              >
                                <b className="c-link glowing-text">
                                  Application Link - Click here (Please download your application for future correspondence)
                                </b>
                              </Link>
                            </li>

                            
                          <div
                            style={{
                              marginTop: "12px",
                              marginBottom: "12px",
                              marginLeft: "35px",
                              padding: "7px 25px",
                              borderLeft: "5px solid #d32f2f",
                              background: "#fff7f7",
                              color: "#2c2c2c",
                              fontSize: "0.9rem",
                              lineHeight: "1.7",
                              borderRadius: "6px",
                              boxShadow: "inset 0 0 0 1px rgba(211,47,47,0.08)",
                            }}
                          >
                            
                            <p><strong style={{ color: "#d32f2f" }}>Note:</strong> The application portal has been designed to facilitate a convenient and streamlined application process for both candidates and the Institute. The posts displayed to a candidate in the application portal are based on the basic eligibility parameters entered by the candidate, including Age, Category, Educational Qualification, and Years of Experience, as prescribed for the respective posts in the detailed advertisement.</p>
                            <p>However, the display of a post in the application portal does not mean or imply that the candidate has been finally determined to be eligible for the post. The portal does not validate all the detailed eligibility requirements prescribed in the advertisement, particularly the relevance and nature of experience, specific experience requirements, and other applicable conditions.</p>
                            <p>The information and eligibility claims submitted by the candidate will be subject to detailed scrutiny and verification at a subsequent stage by the appropriate Committee. Final eligibility shall be determined based on the detailed scrutiny of the application and supporting documents in accordance with the provisions of the advertisement.</p>
                            <p>Candidates are therefore advised to carefully read the detailed advertisement and all prescribed eligibility criteria before applying for any post. The candidate shall be responsible for ensuring that he/she fulfills all the prescribed eligibility requirements for the post applied for.</p>
                          </div>

                          </ul>

                          <p className="glowing-text">
                            <b style={{ color: "blue" }}>Important Dates:</b>
                          </p>
                          <ul className="myulcustarrow mt-3">
                            <li>
                              <b>Starting Date for Applying Online: 31-08-2026</b>
                            </li>
                            <li>
                              <b>
                                Closing Date for Applying Online: 30-09-2026 up to
                                05:00 p.m.
                              </b>
                            </li>
                          </ul>

                        
                      </div>
                    </div>
                  </div>

                  {/* Index15 ---------------------- End  */}







                  {/* Index14 ---------------------- start */}

                  <div className="card">
                    <div className="card-header">
                      <h2 className="mb-0">
                        <button
                          className={`faq-btn${
                            activeIndex === 14 ? "" : " collapsed"
                          }`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse14`}
                          onClick={() => handleToggle(14)}
                        >
                          <h3>Staff Recruitment</h3>{" "}
                          <h4>
                            {" "}
                            Advertisement No. IITT/STAFFREC/01/2025 dated
                            14-07-2025
                          </h4>
                        </button>
                      </h2>
                    </div>
                    <div
                      id={`collapse14`}
                      className={`collapse${activeIndex === 14 ? " show" : ""}`}
                      data-bs-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <p className="glowing-text">
                          {/* <b style={{ color: "blue" }}>
                            The Indian Institute of Technology Tirupati, an
                            Institute of National Importance, invites online
                            applications for regular non-teaching staff
                            positions.
                          </b> */}
                          <b style={{ color: "blue" }}>
                            As part of our standard verification process, all the candidates who shortlisted for the selection process are requested to provide additional supporting documents to substantiate their prior work experience. These may include, but are not limited to:
                          </b><br/><br/>
                          <b style={{ color: "blue" }}><i>
                            "Copies of salary slips / EPF statements or UAN details/ ESI (Employees’ State Insurance) contribution records, if applicable/ Form 16 / Income Tax statements reflecting salary from your previous employer/ Bank statements showing salary credits from the claimed organization / Relieving letter or any other statutory employment records."
                          </i></b><br/><br/>
                          <b style={{ color: "blue" }}>
                            Candidates must bring the original documents for verification at the time of document verification. Please note that submission of these documents is an essential requirement of the recruitment process wherever prior experience is mandatory. Failure to produce the required documents may lead to disqualification from further rounds of the selection process.
                          </b>
                        </p>

                        {/* IN this place put a table */}

                        {/* <p className="glowing-text">
                          <b>Update: </b>
                          <b style={{ color: "blue" }}>
                            A "Post Serial Number" has been allotted to every
                            applicant against their Application Number. Please
                            log in to the application portal to find your "Post
                            Serial Number." All communication will be made using
                            your Post Serial Number only. Further, please
                            download the application (PDF format) for future
                            correspondence.
                          </b>
                        </p> */}

                        <p>
                          <b>
                            Please find the below table for the further updates:
                          </b>
                        </p>
                        <Table
                          bordered
                          responsive
                          className="mt-3 table table-striped"
                        >
                          <thead>
                            <tr className="c-tablehead">
                              <th>Name of the Post</th>
                              <th>Syllabus & Selection Criteria	</th>
                              <th>Status of Application</th>
                              <th>Date of Examination / Interview</th>
                              <th>Results</th>
                            </tr>
                          </thead>

                          <tbody>
                            {StaffReq2025_1.map((item, index) => (
                              <tr key={index}>
                                <td>{item.NameofthePost}</td>
                                <td>
                                  {typeof item.Syllabus === "string" ? (
                                    item.Syllabus
                                  ) : (
                                    <a
                                      href={item.Syllabus.Link}
                                      style={{
                                        color:
                                          item.Syllabus.Style &&
                                          item.Syllabus.Style.color,
                                      }}
                                      target="_blank"
                                    >
                                      {item.Syllabus.Text}
                                    </a>
                                  )}
                                </td>
                                   <td>
                                                                        {item.StatusofApplication.map((status, i) => (
                                                                            <div key={i}>
                                                                                <a className="text-maroon" href={status.Link} target="_blank" >{status.Text}</a>
                                                                            </div>
                                                                        ))}
                                                                    </td>
                                {/* <td>
                                  {item.StatusofApplication.map((status, i) => (
                                    <div key={i}>
                                      <a
                                        className={`text-maroon ${
                                          status.glowstatus === "yes"
                                            ? "glowing-text"
                                            : ""
                                        }`}
                                        href={status.Link}
                                        target="_blank"
                                      >
                                        {status.Text}
                                      </a>
                                    </div>
                                  ))}
                                </td> */}
                                <td>{item.DateofExamination}</td>
                                <td>
                                  {Array.isArray(item.Results) ? (
                                    item.Results.map((result, idx) => (
                                      <div key={idx}>
                                        <a
                                          className={`text-maroon ${
                                            result.glowstatus === "yes"
                                              ? "glowing-text"
                                              : ""
                                          }`}
                                          href={result.Link}
                                          style={{
                                            color:
                                              result.color ||
                                              (result.Style &&
                                                result.Style.color),
                                          }}
                                          target="_blank"
                                        >
                                          {result.Text}
                                        </a>
                                      </div>
                                    ))
                                  ) : (
                                    <a
                                      className={`text-marron ${
                                        item.Results.glowstatus == "yes"
                                          ? "glowing-text"
                                          : ""
                                      }`}
                                      href={item.Results.Link}
                                      style={{
                                        color:
                                          item.Results.Style &&
                                          item.Results.Style.color,
                                      }}
                                      target="_blank"
                                    >
                                      {item.Results.Text}
                                    </a>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>

                        <p className="glowing-text">
                          <ul className="myulcustarrow mt-3">
                            <li>
                              <Link
                                to="https://files.iittp.ac.in/pdfs/recruitment/2025/July/Detailed_advertisement-Staff_01-2025_IITT_14thJuly2025.pdf"
                                target="_blank"
                              >
                                <b className="c-link">
                                  Detailed Advertisement (English Version) - Click Here
                                </b>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="https://files.iittp.ac.in/pdfs/recruitment/2025/July/Detailed_advertisement-Hindi-Staff_01-2025_IITT_14thJuly2025.pdf"
                                target="_blank"
                              >
                                <b className="c-link">
                                  Detailed Advertisement (Hindi Version) - Click Here
                                </b>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="https://files.iittp.ac.in/pdfs/recruitment/2025/July/NewspaperAdvertisement.pdf"
                                target="_blank"
                              >
                                <b className="c-link">
                                 Newspaper Advertisement -Click Here
                                </b>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="http://iittp.plumerp.co.in/prod/iittirupati/staffactiveadv"
                                target="_blank"
                              >
                                <b className="c-link">
                                  Application Link - Click here (Please download your application for future correspondence)
                                </b>
                              </Link>
                            </li>
                            {/* <li>
                              <Link
                                to="https://files.iittp.ac.in/pdfs/recruitment/2024/September/Detailed_Advertisement-Staff_02-2024_Hindi_Version.pdf"
                                target="_blank"
                              >
                                <b className="c-link">
                                  Detailed Advertisement in Hindi Version -
                                  Click here
                                </b>
                              </Link>
                            </li> */}
                          </ul>
                        </p>

                        {/* <p>
                                                  <b>
                                                      Further, download the
                                                      application for the
                                                      furture correspondence.
                                                  </b>
                                              </p> */}
                        {/* <p className="glowing-text">
                          <b style={{ color: "blue" }}>Important Dates:</b>
                        </p>
                        <ul className="myulcustarrow mt-3">
                          <li>
                            <b>Starting Date for Applying Online: 14-07-2025</b>
                          </li>
                          <li>
                            <b>
                              Closing Date for Applying Online: 13-08-2025 <del>up to
                              17:00 hrs</del>. The deadline for submitting online applications has been extended until 11:59 PM today (13.08.2025).
                            </b>
                          </li>
                        </ul> */}
                      </div>
                    </div>
                  </div>

                  {/* Index14 ---------------------- End  */}

                  {/* Index11 ---------------------- start */}

                  {/* <div className="card">
                                        <div className="card-header">
                                            <h2 className="mb-0">
                                                <button
                                                    className={`faq-btn${activeIndex === 11 ? '' : ' collapsed'}`}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse11`}
                                                    onClick={() =>
                                                        handleToggle(11)
                                                    }
                                                >
                                                    
                                                        <h3> Faculty Recruitment Drive 2024 </h3>
                                                        <h4> Advertisement No. IITT/FACREC/01/2024 Dated January 24, 2024</h4>
                                                    
                                                </button>
                                            </h2>
                                        </div>
                                        <div
                                            id={`collapse11`}
                                            className={`collapse${activeIndex === 11 ? ' show' : ''}`} 
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="card-body">

                                                <b>
                                                    IIT Tirupati, an Institute of national importance declared as such under the Institute of Technology Act, 1961, invites applications from qualified Indian nationals, including Persons of Indian Origin (PIOs) and Overseas Citizens of India (OCIs) for faculty positions at the levels of Assistant Professor, Associate Professor, and Professor in the Departments and research areas as indicated below:
                                                </b>

                                                <ul className="myulcustarrow mt-3">
                                                   
                                                    <li>
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/recruitment/faculty/2024/Detailed_%20Advertisement-FacRec_01_2024.pdf"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">Detailed Advertisement</b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            to="https://recruitment.iittp.ac.in/"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">
                                                                Apply Online (Online application is closed)
                                                            </b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <b>
                                                            Starting Date of Online Application - 24.01.2024
                                                        </b>
                                                    </li>
                                                    <li>
                                                        <b>
                                                            Closing Date of Online Application - 29.02.2024
                                                        </b>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div> */}

                  {/* Index11 ---------------------- End  */}

                  {/* Index0 ---------------------- start */}
                  {/* <div className="card">
                                        <div className="card-header">
                                            <h2 className="mb-0">
                                                <button
                                                   className={`faq-btn${activeIndex === 0 ? '' : ' collapsed'}`}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse0`}
                                                    onClick={() =>
                                                        handleToggle(0)
                                                    }
                                                >
                                                    <h3>
                                                        Staff Recruitment  </h3>
                                                        <h4> Advertisement No.
                                                        IITT/STAFFREC/02/2023
                                                        dated 23 August 2023</h4>
                                                   
                                                </button>
                                            </h2>
                                        </div>
                                        <div
                                            id={`collapse0`}
                                            className={`collapse${activeIndex === 0 ? ' show' : ''}`} 
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="card-body">
                                                
                                                <p  className="glowing-text">
                                                  
                                                    <b>Update: </b>
                                                    <b style={{ color: "blue" }}>
                                                        A “Post Serial Number”
                                                        has been allotted to
                                                        every applicant against
                                                        their Application
                                                        Number. Please log in to
                                                        the Application portal
                                                        to know your “Post
                                                        Serial Number”. All the
                                                        Communication will be
                                                        made through your Post
                                                        Serial Number only.
                                                    </b>
                                                </p>
                                                <p>
                                                    <b>
                                                        Further, download the
                                                        application for the
                                                        furture correspondence.
                                                    </b>
                                                </p>
                                                <p>
                                                    Please find the portal link:{" "}
                                                    <Link
                                                        to="https://iittp.plumerp.co.in/prod/iittirupati/staffrecruitment"
                                                        target="_blank"
                                                    >
                                                        <b className="c-link">Click here</b>
                                                    </Link>
                                                </p>
                                                <p>
                                                    <b>
                                                        Please find the below
                                                        table for the further
                                                        updates:
                                                    </b>
                                                </p>
                                                <Table
                                                    bordered
                                                    responsive
                                                    className="mt-3 table table-striped"
                                                >
                                                    <thead>
                                                        <tr className='c-tablehead'>
                                                            <th>
                                                                Name of the Post
                                                            </th>
                                                            <th>Syllabus</th>
                                                            <th>
                                                                Status of
                                                                Application
                                                            </th>
                                                            <th>
                                                                Date of
                                                                Examination /
                                                                Interview
                                                            </th>
                                                            <th>Results</th>
                                                        </tr>
                                                    </thead>
                                               
                                                        <tbody>
                                                            {StaffReq.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td>{item.NameofthePost}</td>
                                                                    <td>
                                                                        {typeof item.Syllabus === 'string' ? item.Syllabus : (
                                                                            <a href={item.Syllabus.Link} style={{ color: (item.Syllabus.Style && item.Syllabus.Style.color) }} target="_blank" >
                                                                                {item.Syllabus.Text}
                                                                            </a>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {item.StatusofApplication.map((status, i) => (
                                                                            <div key={i}>
                                                                                <a className="text-maroon" href={status.Link} target="_blank" >{status.Text}</a>
                                                                            </div>
                                                                        ))}
                                                                    </td>
                                                                    <td>{item.DateofExamination}</td>
                                                                    <td>
                                                                        {Array.isArray(item.Results) ? (
                                                                            item.Results.map((result, idx) => (
                                                                                <div key={idx}>
                                                                                    <a className={`text-maroon ${result.glowstatus === "yes" ? 'glowing-text' : ''}`} href={result.Link} style={{ color: (result.color || (result.Style && result.Style.color)) }} target="_blank" >
                                                                                      {result.Text}
                                                                                    </a>
                                                                                </div>
                                                                            ))
                                                                        ) : (
                                                                                <a className={`text-marron ${item.Results.glowstatus == "yes" ? 'glowing-text' : ''}`} href={item.Results.Link} style={{ color: (item.Results.Style && item.Results.Style.color) }} target="_blank" >
                                                                                {item.Results.Text}
                                                                            </a>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                 
                                                </Table>

                                                <h4 className='c-headline mt-5 mb-3'>Question Papers</h4>

                                                <ul className="myulcustarrow">



                                                  
                                                 
                                                    {Question2023.map((item2,index2) => (

                                                   <li key={index2}>
                                                   
                                                       <Link
                                                           to={item2.link}
                                                           target="_blank"
                                                       >
                                                                <b className="text-maroon">
                                                               {item2.name}
                                                           </b>
                                                       </Link>
                                                    </li>
                                                    )
                                                )}
                                       
                                                    
                                                </ul>
                                            </div>
                                        </div>
                                    </div> */}
                  {/* Index0 ---------------------- end */}

                  {/* Index1 ---------------------- start */}
                  {/* <div className="card">
                                        <div className="card-header">
                                            <h2 className="mb-0">
                                                <button
                                                   className={`faq-btn${activeIndex === 1 ? '' : ' collapsed'}`}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse1`}
                                                    onClick={() =>
                                                        handleToggle(1)
                                                    }
                                                >
                                                    
                                                      <h3>  Advertisement for the
                                                        Post of Registrar</h3>
                                                    <h4>Advertisement No.
                                                        IITT/Staff RMT/01/2023
                                                        dated 03 January, 2023
                                                    </h4>
                                                </button>
                                            </h2>
                                        </div>
                                        <div
                                            id={`collapse1`}
                                            className={`collapse${activeIndex === 1 ? ' show' : ''}`} 
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="card-body">
                                                <ul className="myulcustarrow">
                                                    <li>
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/recruitment/2022/Advertisement No. IITTStaff RMT012023-Registrar.pdf"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">
                                                                Advertisement
                                                                for the position
                                                                of Registrar of
                                                                the Institute.
                                                            </b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/recruitment/2022/User Manual for Staff Recruitment Portal(Registrar Post).pdf"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">User Manual</b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            to="https://iittp.plumerp.co.in/prod/iittirupati/iittstaffrecruitment"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">
                                                                Apply Online
                                                                (Online
                                                                application is
                                                                closed)
                                                            </b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <b>
                                                            Starting Date of
                                                            Online Application -
                                                            05.01.2023
                                                        </b>
                                                    </li>
                                                    <li>
                                                        <b>
                                                            Closing Date of
                                                            Online Application -
                                                            31.01.2023
                                                        </b>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div> */}
                  {/* Index1 ---------------------- end */}
                  {/* Index2 -----------------------start*/}
                  {/* <div className="card">
                                        <div className="card-header">
                                            <h2 className="mb-0">
                                                <button
                                                   className={`faq-btn${activeIndex === 2 ? '' : ' collapsed'}`}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse2`}
                                                    onClick={() =>
                                                        handleToggle(2)
                                                    }
                                                >
                                                  
                                                       <h3> Faculty Special
                                                        Recruitment Drive 2022 </h3>
                                                    <h4>
                                                        Advertisement No.
                                                        IITT/FACREC/SRD/01/2022
                                                        Dated December 07, 2022
                                                    </h4>
                                                </button>
                                            </h2>
                                        </div>
                                        <div
                                            id={`collapse2`}
                                            className={`collapse${activeIndex === 2 ? ' show' : ''}`} 
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="card-body">
                                                <ul className="myulcustarrow">
                                                    <li>
                                                        <b>
                                                            Interviews of
                                                            Special Recruitment
                                                            Drive 2022
                                                            (Advertisement No.
                                                            IITT/FACREC/SRD/01/2022
                                                            Dated December 07,
                                                            2022) for the
                                                            faculty positions in
                                                            various departments
                                                            have been completed,
                                                            and the appointment
                                                            letters to the
                                                            selected candidates
                                                            have been sent.
                                                        </b>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/recruitment/faculty/2022-23/Advertisement SRD 01 of 2022 dt 07 Dec 2022.pdf"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">
                                                                Advertisement
                                                                for the position
                                                                of Assistant
                                                                Professor
                                                                Grade-I in the
                                                                various
                                                                departments of
                                                                the Institute.
                                                            </b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            to="https://recruitment.iittp.ac.in/"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">
                                                                Apply Online
                                                                (Online
                                                                application is
                                                                closed)
                                                            </b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <b>
                                                            Starting Date of
                                                            Online Application -
                                                            07.12.2022
                                                        </b>
                                                    </li>
                                                    <li>
                                                        <b>
                                                            Closing Date of
                                                            Online Application -
                                                            30.12.2022
                                                        </b>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div> */}
                  {/* Index2 ---------------------- end */}
                  {/* Index3 ----------------------- start*/}
                  {/* <div className="card">
                                        <div className="card-header">
                                            <h2 className="mb-0">
                                                <button
                                                   className={`faq-btn${activeIndex === 3 ? '' : ' collapsed'}`}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse3`}
                                                    onClick={() =>
                                                        handleToggle(3)
                                                    }
                                                >
                                                   <h3>
                                                        Faculty Special
                                                        Recruitment Drive 2021</h3>
                                                    <h4>Advertisement No.
                                                        IITT/SRD/FAC - RMT
                                                        -01/2021
                                                    </h4>
                                                </button>
                                            </h2>
                                        </div>
                                        <div
                                            id={`collapse3`}
                                            className={`collapse${activeIndex === 3 ? ' show' : ''}`} 
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="card-body">
                                                <div className="uk-panel uk-panel-box">
                                                    <h4>
                                                        <b>
                                                            Advertisement No.
                                                            IITT/SRD/FAC - RMT
                                                            -01/2021 is
                                                            cancelled due to
                                                            administrative
                                                            reasons -
                                                            <a
                                                                href="https://files.iittp.ac.in/pdfs/recruitment/faculty/Cancellation of SRD 01 of 2021.pdf"
                                                                target="_blank;"
                                                            >
                                                                {" "}
                                                                Cancellation
                                                                Order{" "}
                                                            </a>
                                                        </b>
                                                    </h4>

                                                    <h4>
                                                        Advertisement No.
                                                        IITT/SRD/FAC –
                                                        RMT-01/2021 dated{" "}
                                                        <b>
                                                            {" "}
                                                            17<sup>th</sup>{" "}
                                                            November 2021
                                                        </b>
                                                    </h4>

                                                    <p>
                                                        The last date for
                                                        receipt of online
                                                        applications for faculty
                                                        positions advertised
                                                        vide advertisement No.
                                                        IIT
                                                        T/SRD/Fac-RMT/01/2021
                                                        dated 17-11-2021 is
                                                        extended up to
                                                        27-12-2021.
                                                        <br />
                                                        IIT Tirupati (an
                                                        Institute of national
                                                        importance declared as
                                                        such under the Institute
                                                        of Technology Act, 1961)
                                                        invites applications
                                                        from SC, ST, OBC-NCL,
                                                        and PwD candidates with
                                                        an established record of
                                                        independent high-quality
                                                        research and commitment
                                                        to teaching for faculty
                                                        positions at the levels
                                                        of ASSISTANT PROFESSOR.
                                                        <br />
                                                        Opening date for on-line
                                                        registration:{" "}
                                                        <b>17-11-2021</b>
                                                        <br />
                                                        Closing date for
                                                        submission of
                                                        applications online:{" "}
                                                        <b>27-12-2021</b>
                                                    </p>

                                                    <ul className="myulcustarrow">
                                                        <li>
                                                            <Link
                                                                to="/doc/SRD for faculty recruitment 2021.pdf"
                                                                target="_blank"
                                                            >
                                                                <b className="c-link">
                                                                    Advertisement
                                                                </b>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link
                                                                to="https://recruitment.iittp.ac.in/faculty"
                                                                target="_blank"
                                                            >
                                                                <b className="c-link">
                                                                    Apply Online
                                                                    (Online
                                                                    application
                                                                    is closed)
                                                                </b>
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                  {/*Index3 -------------end */}
                  {/*Index4---------------start*/}
                  {/* <div className="card">
                                        <div className="card-header">
                                            <h2 className="mb-0">
                                                <button
                                                   className={`faq-btn${activeIndex === 4 ? '' : ' collapsed'}`}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse4`}
                                                    onClick={() =>
                                                        handleToggle(4)
                                                    }
                                                >
                                                    <h4>
                                                        Previous Staff
                                                        Recruitment details
                                                        (Advertisements)
                                                    </h4>
                                                </button>
                                            </h2>
                                        </div>
                                        <div
                                            id={`collapse4`}
                                            className={`collapse${activeIndex === 4 ? ' show' : ''}`} 
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="card-body">
                                                <ul className="myulcustarrow">
                                                <li>
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/recruitment/2023/Detailed%20advertisement%20-%20Staff%2002-2023.pdf"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">
                                                            Advertisement No. IITT/STAFFREC/02/2023 dated 23 August 2023
                                                            </b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/recruitment/2022/Advertisement%20No.%20IITTStaff%20RMT012023-Registrar.pdf"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">
                                                            Advertisement No. IITT/Staff RMT/01/2023 dated 03 January 2023
                                                            </b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/recruitment/2022/Advertisement_Staff RMT 01 of 2022.pdf"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">
                                                                Adv. No.
                                                                IITT/Staff
                                                                RMT/01/2022
                                                                dated 07.10.2022
                                                            </b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/recruitment/2021/staff/Staff recruitment advertisement 2020_21.pdf"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">
                                                                Recruitment No:
                                                                IITTP/Staff
                                                                RMT-01/2020
                                                            </b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/recruitment/2021/JA Additional.pdf"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">
                                                                Update on Junior
                                                                Assistant
                                                                Recruitment
                                                            </b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/recruitment/2019/staff/staff_advertisement_IITTPStaff RMT-012019.pdf"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">
                                                                Recruitment No:
                                                                IITTP/Staff
                                                                RMT-01/2019
                                                            </b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/recruitment/2018/staff/staff_advertisement_IITTPStaff RMT-012018.pdf"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">
                                                                Recruitment No:
                                                                IITTP/Staff
                                                                RMT-01/2018
                                                            </b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/recruitment/2017/staff/advertisement_non_faculty_IITTPStaff RMT2017.pdf"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">
                                                                Recruitment No:
                                                                IITTP/Staff
                                                                RMT/2017
                                                            </b>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            to="https://files.iittp.ac.in/pdfs/recruitment/2017/staff/advertisement_non_faculty_2_IITTPStaff RMT-022017.pdf"
                                                            target="_blank"
                                                        >
                                                            <b className="c-link">
                                                                Recruitment No:
                                                                IITTP/Staff
                                                                RMT-02/2017
                                                            </b>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div> */}
                  {/*Index4 --------------- end*/}
                  {/*Index5 --------------- start*/}
                  <div className="card">
                    <div className="card-header">
                      <h2 className="mb-0">
                        <button
                          className={`faq-btn${
                            activeIndex === 5 ? "" : " collapsed"
                          }`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse5`}
                          onClick={() => handleToggle(5)}
                        >
                          <h4>
                            Previous Examination Question Papers (Question
                            Papers)
                          </h4>
                        </button>
                      </h2>
                    </div>
                    <div
                      id={`collapse5`}
                      className={`collapse${activeIndex === 5 ? " show" : ""}`}
                      data-bs-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <PrevQPFile />
                        <ul class="myulcustarrow">
                          {PrevQP.map((qp, indx) => (
                            <li key={indx}>
                              <Link to={qp.link} target="_blank">
                                <b className="c-link">{qp.name}</b>
                              </Link>{" "}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <br />
                </div>
                <h5>
                  <Link
                    to="https://files.iittp.ac.in/pdfs/general/recordretentionschedule.pdf"
                    target="_blank"
                  >
                    <b className="c-link">Retention of recruitment records</b>
                  </Link>
                </h5>
              </div>
            </div>
          </Row>
        </div>
      </section>
    </>
  );
}

export default Main;
